import { FormControl } from '@axo/ui-core/components/form/FormControl';
import { forwardRef, ForwardRefRenderFunction, ReactNode, useId } from 'react';
import { IInputPrimaryState } from '../../models/input.model';
import { UIInputState } from '../../models/state-to-ui-input-state';
import FormattedInputUI, {
  IFormattedInputUI,
} from '../FormattedInput/FormattedInputUI';
import {
  IInputInfoBoxUI as IInputInfoBox,
  InfoType,
} from '../InputInfoBox/InputInfoBox.types';
import InputInfoBoxUI from '../InputInfoBox/InputInfoBoxUI';
import InputStateBoxUI from '../InputStateBox/InputStateBoxUI';
import { InputWrapperUI } from '../InputWrapper/InputWrapperUI';

export interface ITextInputUI extends IFormattedInputUI {
  infoBox?: IInputInfoBox;
  label?: string;
  warning?: string;
  state?: IInputPrimaryState;
  confirmationPrompt?: ReactNode;
}

const TextInputUI: ForwardRefRenderFunction<HTMLInputElement, ITextInputUI> = (
  {
    infoBox,
    label,
    warning,
    state = 'undetermined',
    confirmationPrompt,
    ...props
  },
  ref
) => {
  const inputId = useId();
  const infoId = useId();

  const isError = infoBox?.type === InfoType.ERROR;

  return (
    <FormControl state={UIInputState[state]}>
      <InputWrapperUI htmlFor={inputId} label={label}>
        <InputInfoBoxUI
          {...infoBox}
          infoId={infoId}
          confirmationPrompt={confirmationPrompt}
        >
          <InputStateBoxUI primaryState={state}>
            <FormattedInputUI
              autoComplete={'off'}
              type="text"
              id={inputId}
              aria-invalid={isError}
              aria-errormessage={isError ? infoId : undefined}
              aria-describedby={!isError && infoBox?.type ? infoId : undefined}
              {...(state === 'disabled' && { disabled: true })}
              {...props}
              ref={ref}
              primaryState={state}
            />
          </InputStateBoxUI>
        </InputInfoBoxUI>
      </InputWrapperUI>
    </FormControl>
  );
};

export default forwardRef(TextInputUI);
